export const colors = {
  1: '#6658dd',
  2: '#f1556c',
}

export type TIncoTerm = {
  name: string
  description: string
  marineOnly?: boolean
  borderLeft?: boolean
  borderRight?: boolean
}

export function getTerms(): Array<TIncoTerm> {
  return [
    {
      name: 'exw',
      description: `${i18n.t('inco_exw_description', 'Ab Werk')} (EX Works)`,
    },
    {
      name: 'fca',
      description: `${i18n.t(
        'inco_fca_description',
        'Frei Frachtführer',
      )} (Free CArrier)`,
    },
    {
      name: 'fas',
      description: `${i18n.t(
        'inco_fas_description',
        'Frei Längsseite Schiff',
      )} (Free Alongside Ship)`,
      marineOnly: true,
      borderLeft: true,
    },
    {
      name: 'fob',
      description: `${i18n.t(
        'inco_fob_description',
        'Frei an Bord',
      )} (Free On Board)`,
      marineOnly: true,
    },
    {
      name: 'cfr',
      description: `${i18n.t(
        'inco_cfr_description',
        'Kosten und Fracht',
      )} (Cost And FReight)`,
      marineOnly: true,
    },
    {
      name: 'cif',
      description: `${i18n.t(
        'inco_cif_description',
        'Kosten, Versicherung und Fracht',
      )} (Cost Insurance Freight)`,
      marineOnly: true,
      borderRight: true,
    },
    {
      name: 'cpt',
      description: `${i18n.t(
        'inco_cpt_description',
        'Frachtfrei',
      )} (Carriage Paid To)`,
    },
    {
      name: 'cip',
      description: `${i18n.t(
        'inco_cip_description',
        'Frachtfrei versichert',
      )} (Carriage Insurance Paid)`,
    },
    {
      name: 'dap',
      description: `${i18n.t(
        'inco_dap_description',
        'Geliefert benannter Ort',
      )} (Delivered At Place)`,
    },
    {
      name: 'dpu',
      description: `${i18n.t(
        'inco_dpu_description',
        'Geliefert benannter Ort entladen',
      )} (Delivered at Place Unloaded)`,
    },
    {
      name: 'ddp',
      description: `${i18n.t(
        'inco_ddp_description',
        'Geliefert verzollt',
      )} (Delivered Duty Paid)`,
    },
  ]
}

export function getTasks(): { description: string }[] {
  return [
    {
      description: i18n.t('packeging', 'Verpackung'),
    },
    {
      description: i18n.t('loading_fees', 'Ladegebühren'),
    },
    {
      description: i18n.t(
        'transport_to_export_site',
        'Transport zum Export-Standort',
      ),
    },
    {
      description: i18n.t(
        'export_customs_taxes_and_customs_clearance',
        'Ausfuhrzölle, Steuern und Zollabfertigung',
      ),
    },
    {
      description: i18n.t(
        'terminal_costs_place_of_origin',
        'Terminalkosten Herkunftsort',
      ),
    },
    {
      description: i18n.t(
        'loading_on_the_transport',
        'Verladung auf den Transport',
      ),
    },
    {
      description: i18n.t('transport_costs', 'Transportkosten'),
    },
    // {
    //   description: i18n.t("insurance", "Versicherung")
    // },
    {
      description: i18n.t(
        'terminal_costs_place_of_destination',
        'Terminalkosten Bestimmungsort',
      ),
    },
    {
      description: i18n.t('transport_to_target', 'Transport zum Zielort'),
    },
    {
      description: i18n.t(
        'import_customs_taxes_and_customs_clearance',
        'Einfuhrzölle, Steuern und Zollabfertigung',
      ),
    },
  ]
}

export const incoSplit = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1],
  [2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1],
  // [0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
  [2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1],
  [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
  [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
]
